import { useState, useLayoutEffect, useRef } from "react"
import PropTypes from "prop-types"
import { toUpper, trim } from "lodash"
import { DialogContent, DialogActions, Button, FormControl, FormGroup, TextField, Typography } from "@mui/material"
import "./styles.scss"

const DEFAULT_KEYWORD = ""

export default function ConfirmDialog({ text, keyword: confirmKeyword, cta, action, onClose }) {
  const [keyword, setKeyword] = useState(DEFAULT_KEYWORD)
  const [minWidth, setMinWidth] = useState()
  const input = useRef()

  // Make sure the width of the popup is large enough for the confirm box placeholder text
  // otherwise it looks ugly
  useLayoutEffect(() => {
    setMinWidth(input.current.firstChild.firstChild.clientWidth)
  }, [input])

  const isDisabled = toUpper(trim(keyword)) !== toUpper(trim(confirmKeyword))

  const reset = () => {
    setKeyword(DEFAULT_KEYWORD)
  }

  const handleClose = () => onClose(reset)

  const handleAction = () => {
    if (isDisabled) { return false }

    action(handleClose())
  }

  const onChange = (e) => {
    const { target: { value } } = e
    setKeyword(value)
  }

  return <>
    <DialogContent className="delete-confirm">
      <Typography variant="body2">{text}</Typography>
      <form onSubmit={handleAction}>
        <FormGroup style={{ minWidth }}>
          <FormControl variant="standard" ref={input}>
            <TextField
              variant="standard"
              id="keyword"
              name="keyword"
              multiline
              label={`Please type ${toUpper(confirmKeyword)} to confirm`}
              onChange={onChange}
              value={keyword}
              required
              autoFocus
            />
          </FormControl>
        </FormGroup>
      </form>
    </DialogContent>
    <DialogActions>
      <Button onClick={handleClose} color="secondary">
        Cancel
      </Button>
      <Button className="danger" disabled={isDisabled} onClick={handleAction} color="primary">
        {cta}
      </Button>
    </DialogActions>
  </>
}

ConfirmDialog.propTypes = {
  text: PropTypes.string,
  keyword: PropTypes.string.isRequired,
  cta: PropTypes.string.isRequired,
  action: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
}
